var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameEndingProps = function SvgIconStorygameEndingProps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000",
    fillOpacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5v5.47h5.47V4.5H4.5ZM4 3a1 1 0 0 0-1 1v6.47a1 1 0 0 0 1 1h6.47a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4ZM4.5 14.03v5.47h5.47v-5.47H4.5Zm-.5-1.5a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h6.47a1 1 0 0 0 1-1v-6.47a1 1 0 0 0-1-1H4ZM14.03 4.5v5.47h5.47V4.5h-5.47Zm-.5-1.5a1 1 0 0 0-1 1v6.47a1 1 0 0 0 1 1H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6.47ZM14.03 14.03v5.47h5.47v-5.47h-5.47Zm-.5-1.5a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1H20a1 1 0 0 0 1-1v-6.47a1 1 0 0 0-1-1h-6.47Z"
  }))));
};
export default SvgIconStorygameEndingProps;